import React from 'react'
import Btn, { FormBtn } from "components/Btn";
import { destructureErrorMessage } from "Helper";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { apiRequest } from "store/Misc/apiRequest";
import { withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setFormLoading, previewModal } from 'store/slices/miscSlice';

export default withTranslation()(function Propmpt({ t, msg, url, btnText, className, successMsg }) {
  const method = useForm({mode: 'all'})
  const dispatch = useDispatch()
  
  const {handleSubmit} = method

  const submit = async () => {
    dispatch(setFormLoading())
    try {
      await apiRequest({
        method: 'get',
        url
      })
      toast.success(successMsg)
      dispatch(previewModal('close'))
    } catch({message}) {
      destructureErrorMessage(message).map(msg => {
        return toast.error(msg, {autoClose: 15000})
      })
    }
    dispatch(setFormLoading('close'))
  }

  return (
    <li className="">
      <FormProvider {...method}>
        <form onSubmit={handleSubmit(submit)}>
          <p className="text-center p-5">{ msg }</p>

          <div className="grid grid-cols-2 gap-8 px-10">
            <div className={`w-full h-10 rounded-lg overflow-hidden border border-primary bg-white`}>
              <Btn 
                content={t('misc.cancel')}
                className="h-10 w-full"
                variant="outlined"
                textColor="text-primary font-medium"
              />
            </div>

            <div className={`w-full h-10 rounded-lg overflow-hidden`}>
              <FormBtn 
                content={btnText}
                className={`h-10 w-full text-white font-medium ${ btnText === 'Block' ? 'bg-danger' : 'bg-success'}`}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </li>
  )
})